import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 4,
  "data-error": "unknown type"
}

import {
    type ProductGalleryItem,
    type AdvertItem,
    type FillerItem,
    type ProductListItem,
} from "../../list-item";
import {
    type PropType,
    onMounted,
    onBeforeUnmount,
    getCurrentInstance,
} from "vue";
import type { ListController } from "../../list-controller";

import product from "./product.vue";
import { type OverwriteSettings } from "../../../../../commons/product/overwrite-settings";
import ProductGallery from "../common/product-gallery.vue";
import advert from "./advert.vue";
import { type ProductRegistrationResult } from "../common/product-updater";
import { createItemObservator } from "../common/item-observation";
// import { createItemObservator } from "../common/item-observation";
// const advert = defineAsyncComponent(
//     () =>
//         import(
//             /* webpackFetchPriority: "high" */
//             "./advert.vue"
//         )
// );


const __default__ = {
    model: {
        prop: "item",
    },
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'item',
  props: {
    forceLazyLoadImage: Boolean,
    item: {
        type: Object as PropType<
            | ProductListItem
            | AdvertItem
            | ProductGalleryItem
            | { type: never; filler: true }
            | FillerItem
        >,
        required: true,
    },
    isGalleryItem: Boolean,
    mobile: Boolean,
    filler: Boolean,
    forceLink: Boolean,
    listController: {
        type: Object as PropType<ListController>,
    },
    isLast: Boolean,
    isFirstOfPage: Boolean,
    scaleOfScreen: {
        type: Number,
        default: 1,
    },
    indexOfList: Number,
    overwriteActionButtonText: String,
    overwriteActionButton: Boolean,
    actionButtonLoading: Boolean,
    expectedContentType: String,
    overwriteSettings: Object as PropType<OverwriteSettings>,
    visible: {
        type: Boolean,
        default: true,
    },
    registration: Object as PropType<ProductRegistrationResult>,
},
  emits: ["action-button-click", "input", "mounted", "unmount"],
  setup(__props) {



const props = __props;

const instance = getCurrentInstance();
const itemObservator = createItemObservator(
    instance,
    () => props.isLast,
    () => props.item,
    () => props.listController,
    () => props.isFirstOfPage
);

onMounted(() => {
    itemObservator?.start(props);
});

onBeforeUnmount(() => {
    itemObservator?.stop();
});

return (_ctx: any,_cache: any) => {
  return (__props.filler || ('filler' in __props.item && __props.item.filler === true))
    ? (_openBlock(), _createBlock(product, {
        key: 0,
        link: __props.forceLink && __props.item.type === 'product' ? __props.item.link : undefined,
        "expected-content-type": __props.expectedContentType,
        mobile: __props.mobile,
        visible: __props.visible,
        onMounted: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('mounted', $event))),
        onUnmount: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('unmount', $event)))
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ], undefined, true),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["link", "expected-content-type", "mobile", "visible"]))
    : (__props.item.type === 'product')
      ? (_openBlock(), _createBlock(product, {
          "force-lazy-load-image": __props.forceLazyLoadImage,
          key: __props.item.productId,
          item: __props.item,
          "is-gallery-item": __props.isGalleryItem,
          link: __props.item.link,
          "overlay-text": __props.item.overlayText ?? undefined,
          "overlay-text-type": __props.item.overlayTextType ?? undefined,
          "third-party-stamp": __props.item.thirdPartyStamp,
          "related-auction-stamp": __props.item.relatedAuctionStamp,
          "related-shop-stamp": __props.item.relatedShopStamp,
          "index-of-list": __props.indexOfList,
          "product-id": __props.item.productId,
          "scale-of-screen": __props.scaleOfScreen,
          "product-name": __props.item.productName,
          "onUpdate:productName": _cache[2] || (_cache[2] = ($event: any) => ((__props.item.productName) = $event)),
          "seconds-left": __props.item.timeTotalSeconds,
          "onUpdate:secondsLeft": _cache[3] || (_cache[3] = ($event: any) => ((__props.item.timeTotalSeconds) = $event)),
          "expected-content-type": __props.expectedContentType,
          "time-is-not-started": __props.item.timeIsNotStarted,
          "onUpdate:timeIsNotStarted": _cache[4] || (_cache[4] = ($event: any) => ((__props.item.timeIsNotStarted) = $event)),
          "image-info": __props.item,
          "is-auction": __props.item.isAuction,
          "is-buynow": __props.item.isBuyNow,
          "is-shop": __props.item.isShop,
          "product-value": __props.item.value,
          "onUpdate:productValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.item.value) = $event)),
          registration: __props.registration,
          page: __props.item.page,
          price: __props.item.price,
          "onUpdate:price": _cache[6] || (_cache[6] = ($event: any) => ((__props.item.price) = $event)),
          "has-bid": __props.item.hasBid,
          "onUpdate:hasBid": _cache[7] || (_cache[7] = ($event: any) => ((__props.item.hasBid) = $event)),
          "tracking-info": __props.item.trackingInfo ?? undefined,
          onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('input', $event))),
          mobile: __props.mobile,
          "overwrite-action-button": __props.overwriteActionButton,
          "overwrite-action-button-text": __props.overwriteActionButtonText,
          "overwrite-settings": __props.overwriteSettings,
          "action-button-loading": __props.actionButtonLoading,
          onActionButtonClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('action-button-click', $event))),
          visible: __props.visible,
          onMounted: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('mounted', $event))),
          onUnmount: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('unmount', $event)))
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ], undefined, true),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["force-lazy-load-image", "item", "is-gallery-item", "link", "overlay-text", "overlay-text-type", "third-party-stamp", "related-auction-stamp", "related-shop-stamp", "index-of-list", "product-id", "scale-of-screen", "product-name", "seconds-left", "expected-content-type", "time-is-not-started", "image-info", "is-auction", "is-buynow", "is-shop", "product-value", "registration", "page", "price", "has-bid", "tracking-info", "mobile", "overwrite-action-button", "overwrite-action-button-text", "overwrite-settings", "action-button-loading", "visible"]))
      : (__props.item.type === 'advert')
        ? (_openBlock(), _createBlock(advert, {
            key: 2,
            item: __props.item,
            onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('input', $event))),
            "scale-of-screen": __props.scaleOfScreen,
            mobile: __props.mobile,
            visible: __props.visible,
            onMounted: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('mounted', $event))),
            onUnmount: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('unmount', $event)))
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ], undefined, true),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["item", "scale-of-screen", "mobile", "visible"]))
        : (__props.item.type === 'gallery')
          ? (_openBlock(), _createBlock(ProductGallery, {
              key: 3,
              item: __props.item,
              onMounted: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('mounted', $event))),
              onUnmount: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('unmount', $event)))
            }, null, 8 /* PROPS */, ["item"]))
          : (_openBlock(), _createElementBlock("li", _hoisted_1))
}
}

})